import { ReactElement } from 'react';

import { TFunction } from '@mint-lib/i18n';
import {
  ArrowDown,
  Arrows,
  ChannelAddressableTv,
  ChannelAdserver,
  ChannelAffiliation,
  ChannelBrandedContent,
  ChannelBrandSafety,
  ChannelChatBot,
  ChannelCinema,
  ChannelDem,
  ChannelDirectMedia,
  ChannelDisplay,
  ChannelDmp,
  ChannelDooh,
  ChannelDsp,
  ChannelEvents,
  ChannelInfluencerMarketing,
  ChannelMagazine,
  ChannelMetasearch,
  ChannelMgm,
  ChannelMobile,
  ChannelNative,
  ChannelNetwork,
  ChannelNewspaper,
  ChannelOfflineRadio,
  ChannelOfflineTv,
  ChannelOoh,
  ChannelOrganic,
  ChannelPaidProgrammatic,
  ChannelPayTv,
  ChannelProgrammaticRadio,
  ChannelPromocode,
  ChannelPublisher,
  ChannelRetail,
  ChannelSearch,
  ChannelSocial,
  ChannelVideo,
  ChannelWebAnalytics,
  CircleDash,
} from '@mint-lib/icons';

type ChannelsAndCategoriesNewType = {
  [index: string]: {
    label: string;
    chipProps: {
      iconComponent: ReactElement;
    };
  };
};

type chipColorType = 'info' | 'purple' | 'teal';

export const INTEGRATION_TYPES_NEW = (t: TFunction) => ({
  one_way: {
    chipProps: {
      label: t('One-Way'),
      color: 'info' as chipColorType,
      icon: <ArrowDown />,
    },
  },
  two_way: {
    chipProps: {
      label: t('Two-Way'),
      color: 'purple' as chipColorType,
      icon: <Arrows />,
    },
  },
  virtual: {
    chipProps: {
      label: t('Virtual'),
      color: 'teal' as chipColorType,
      icon: <CircleDash />,
    },
  },
});

export const CHANNELS_AND_CATEGORIES: ChannelsAndCategoriesNewType = {
  display: {
    label: 'Display',
    chipProps: {
      iconComponent: <ChannelDisplay />,
    },
  },
  adServer: {
    label: 'Ad Server',
    chipProps: {
      iconComponent: <ChannelAdserver />,
    },
  },
  search: {
    label: 'Search',
    chipProps: {
      iconComponent: <ChannelSearch />,
    },
  },
  native: {
    label: 'Native',
    chipProps: {
      iconComponent: <ChannelNative />,
    },
  },
  social: {
    label: 'Social',
    chipProps: {
      iconComponent: <ChannelSocial />,
    },
  },
  addressableTv: {
    label: 'Addressable TV',
    chipProps: {
      iconComponent: <ChannelAddressableTv />,
    },
  },
  adNetwork: {
    label: 'Ad Network',
    chipProps: {
      iconComponent: <ChannelNetwork />,
    },
  },
  video: {
    label: 'Video',
    chipProps: {
      iconComponent: <ChannelVideo />,
    },
  },
  offlineTv: {
    label: 'Offline TV',
    chipProps: {
      iconComponent: <ChannelOfflineTv />,
    },
  },
  offlineRadio: {
    label: 'Offline Radio',
    chipProps: {
      iconComponent: <ChannelOfflineRadio />,
    },
  },
  ooh: {
    label: 'OOH',
    chipProps: {
      iconComponent: <ChannelOoh />,
    },
  },
  organic: {
    label: 'Organic',
    chipProps: {
      iconComponent: <ChannelOrganic />,
    },
  },
  dem: {
    label: 'DEM',
    chipProps: {
      iconComponent: <ChannelDem />,
    },
  },
  dooh: {
    label: 'DOOH',
    chipProps: {
      iconComponent: <ChannelDooh />,
    },
  },
  dmp: {
    label: 'DMP',
    chipProps: {
      iconComponent: <ChannelDmp />,
    },
  },
  mobile: {
    label: 'Mobile',
    chipProps: {
      iconComponent: <ChannelMobile />,
    },
  },
  dsp: {
    label: 'DSP',
    chipProps: {
      iconComponent: <ChannelDsp />,
    },
  },
  programmaticRadio: {
    label: 'Programmatic Radio',
    chipProps: {
      iconComponent: <ChannelProgrammaticRadio />,
    },
  },
  publisher: {
    label: 'Publisher',
    chipProps: {
      iconComponent: <ChannelPublisher />,
    },
  },
  webAnalytics: {
    label: 'Web Analytics',
    chipProps: {
      iconComponent: <ChannelWebAnalytics />,
    },
  },
  brandSafety: {
    label: 'Brand Safety',
    chipProps: {
      iconComponent: <ChannelBrandSafety />,
    },
  },
  chatbot: {
    label: 'Chatbot',
    chipProps: {
      iconComponent: <ChannelChatBot />,
    },
  },
  influencerMarketing: {
    label: 'Influencer Marketing',
    chipProps: {
      iconComponent: <ChannelInfluencerMarketing />,
    },
  },
  brandedContent: {
    label: 'Branded Content',
    chipProps: {
      iconComponent: <ChannelBrandedContent />,
    },
  },
  affiliation: {
    label: 'Affiliation',
    chipProps: {
      iconComponent: <ChannelAffiliation />,
    },
  },
  metasearch: {
    label: 'MetaSearch',
    chipProps: {
      iconComponent: <ChannelMetasearch />,
    },
  },
  payTv: {
    label: 'Pay TV',
    chipProps: {
      iconComponent: <ChannelPayTv />,
    },
  },
  promocode: {
    label: 'Promocode',
    chipProps: {
      iconComponent: <ChannelPromocode />,
    },
  },
  memberGetMember: {
    label: 'Member Get Member',
    chipProps: {
      iconComponent: <ChannelMgm />,
    },
  },
  events: {
    label: 'Events',
    chipProps: {
      iconComponent: <ChannelEvents />,
    },
  },
  magazine: {
    label: 'Magazine',
    chipProps: {
      iconComponent: <ChannelMagazine />,
    },
  },
  newspaper: {
    label: 'Newspaper',
    chipProps: {
      iconComponent: <ChannelNewspaper />,
    },
  },
  cinema: {
    label: 'Cinema',
    chipProps: {
      iconComponent: <ChannelCinema />,
    },
  },
  directMedia: {
    label: 'Direct Media',
    chipProps: {
      iconComponent: <ChannelDirectMedia />,
    },
  },
  paidProgrammatic: {
    label: 'Paid Programmatic',
    chipProps: {
      iconComponent: <ChannelPaidProgrammatic />,
    },
  },
  retail: {
    label: 'Retail',
    chipProps: {
      iconComponent: <ChannelRetail />,
    },
  },
};
